import { initAddToCartButtons } from 'javascripts/watcher/magic-matze-cart';
import store from 'store/dist/store.modern';
import Cookies from 'js-cookie';
import initFigure from '../../components/molecules/figure/figure';
import initSocialEmbed from '../../components/molecules/social-embed/social-embed';
import { COOKIES, COOKIESTATUS } from '../constants';

function initCookieAlert($template, reset = false) {
  const $clone = document.importNode($template.content, true);

  const onConsent = ($cookieAlert) => {
    $cookieAlert.remove();
    if (reset) {
      document.querySelector('.js-cookie-alert-enable')?.focus();
    }

    const $cookiesTechnical = $cookieAlert.querySelector('#cookie-neccessary');
    const $cookiesMarketing = $cookieAlert.querySelector('#cookie-marketing');
    const $cookiesAnalytics = $cookieAlert.querySelector('#cookie-analytics');

    // Marketing cookies
    Object.keys(COOKIES.MARKETING).forEach((key) => {
      const gotValue = COOKIES.MARKETING[key];
      if (gotValue) {
        Cookies.set(
          gotValue?.name,
          $cookiesMarketing?.checked
            ? COOKIESTATUS.ACCEPT
            : COOKIESTATUS.DECLINE,
          {
            path: '/',
            expires: gotValue?.expires,
          }
        );
      }
    });

    initFigure();
    initSocialEmbed();

    // Analytics cookies
    Object.keys(COOKIES.ANALYTICS).forEach((key) => {
      const gotValue = COOKIES.ANALYTICS[key];
      if (gotValue) {
        Cookies.set(
          COOKIES.ANALYTICS[key].name,
          $cookiesAnalytics?.checked
            ? COOKIESTATUS.ACCEPT
            : COOKIESTATUS.DECLINE,
          {
            path: '/',
            expires: COOKIES.ANALYTICS[key]?.expires,
          }
        );
      }
    });

    // Necessary cookies
    if ($cookiesTechnical && $cookiesTechnical.checked) {
      Object.keys(COOKIES.CONSENT).forEach((key) => {
        const gotValue = COOKIES.CONSENT[key];
        if (gotValue) {
          Cookies.set(gotValue?.name, COOKIESTATUS.ACCEPT, {
            path: '/',
            expires: gotValue?.expires,
          });
        }
      });
    }

    initAddToCartButtons();

    const cookieAcceptEvent = new CustomEvent('cookieAccepted', {
      bubbles: true,
      detail: {
        technical: $cookiesTechnical ? $cookiesTechnical.checked : false,
        marketing: $cookiesMarketing ? $cookiesMarketing.checked : false,
        analytics: $cookiesAnalytics ? $cookiesAnalytics.checked : false,
      },
    });
    document.dispatchEvent(cookieAcceptEvent);
  };

  const prefillConsent = ($cookieAlert) => {
    const $cookiesMarketing = $cookieAlert.querySelector('#cookie-marketing');
    const marketingConsent = Object.keys(COOKIES.MARKETING).some(
      (key) => Cookies.get(COOKIES.MARKETING[key].name) === COOKIESTATUS.ACCEPT
    );

    const $cookiesAnalytics = $cookieAlert.querySelector('#cookie-analytics');
    const analyticsConsent = Object.keys(COOKIES.ANALYTICS).some(
      (key) => Cookies.get(COOKIES.ANALYTICS[key].name) === COOKIESTATUS.ACCEPT
    );

    if ($cookiesMarketing) {
      $cookiesMarketing.checked = marketingConsent;
    }
    if ($cookiesAnalytics) {
      $cookiesAnalytics.checked = analyticsConsent;
    }
  };

  const onAcceptAll = ($cookieAlert) => {
    // Check all checkboxes of group cookie-checkbox-group
    $cookieAlert
      .querySelectorAll('input[name="cookie-checkbox-group"]')
      .forEach(($checkbox) => {
        const checkbox = $checkbox;
        checkbox.checked = true;
      });
    onConsent($cookieAlert);
  };

  const onAcceptNecessary = ($cookieAlert) => {
    // Uncheck all checkboxes of group cookie-checkbox-group except necessary
    $cookieAlert
      .querySelectorAll('input[name="cookie-checkbox-group"]')
      .forEach(($checkbox) => {
        const checkbox = $checkbox;
        if (checkbox.id !== 'cookie-neccessary') {
          checkbox.checked = false;
        }
      });
    onConsent($cookieAlert);
  };

  if (Cookies.get('bawu-consent') !== COOKIESTATUS.ACCEPT || reset) {
    document.body.appendChild($clone);
    const $cookieAlert = document.querySelector('.cookie-alert');
    $cookieAlert?.setAttribute('aria-live', 'assertive');
    $cookieAlert?.setAttribute('tabindex', '0');
    const $submitBtns = $cookieAlert.querySelectorAll('.cookie-alert__button');
    prefillConsent($cookieAlert);

    if ($submitBtns.length === 1) {
      $submitBtns[0]
        ?.querySelector('.button')
        ?.addEventListener('click', () => onConsent($cookieAlert));
    } else if ($submitBtns.length > 1) {
      $submitBtns.forEach(($btn) => {
        $btn
          .querySelector('#cookie-accept-all')
          ?.addEventListener('click', () => onAcceptAll($cookieAlert));
        $btn
          .querySelector('#cookie-accept-choice')
          ?.addEventListener('click', () => onConsent($cookieAlert));
        $btn
          .querySelector('#cookie-accept-necessary')
          ?.addEventListener('click', () => onAcceptNecessary($cookieAlert));
      });
    }

    if (reset) {
      $cookieAlert?.focus();
    }
  }
}

document.querySelectorAll('.js-cookie-alert').forEach(($template) => {
  initCookieAlert($template);
});

document.querySelectorAll('.js-cookie-alert-enable').forEach(($trigger) => {
  const $template = document.querySelector('.js-cookie-alert');

  if (!$template) {
    console.warn(
      'No cookie alert template .js-cookie-alert found! Removing node .js-cookie-alert-enable'
    );
    $trigger.remove();
    return;
  }

  $trigger.addEventListener('click', () => {
    initCookieAlert($template, true);
  });
});

export default initCookieAlert;
